<div cdkDrag cdkDragRootElement=".cdk-overlay-pane">
  <div class="{{this.customHeaderClass}}">
    <h2 mat-dialog-title>{{ data.title }}</h2>
    <button id="closeButton" mat-icon-button [mat-dialog-close]="false" aria-label="Close Button">
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <div mat-dialog-content>
    <div class="dialog-content"  *ngIf="data.module != 'config-details' && data.module != 'package-details' && data.module != 'error-details' && data.module != 'partner-provisionedUser' && data.module != 'quick-actions'">
      <div class="{{this.customIconClass}}">
        <mat-icon svgIcon="confirm_dialog_icon"></mat-icon>
      </div>
      <div class="{{this.customContentClass}}" [innerHtml]="data.message"></div>
    </div>
    <div class="dialog-content" *ngIf="data.module == 'config-details'">
      <form class="config-form">
        <mat-form-field class="pss-block-form">
          <mat-label class="mat-label-text">Name</mat-label>
          <input type="text" width="50" [value]="configName" name="comment" matInput
            readonly />
        </mat-form-field>
        <mat-form-field class="pss-block-form">
          <div class="label-text">
            <button mat-button class="copy-button" [cdkCopyToClipboard]="configValue" matTooltip="Copy" matTooltipPosition="above" aria-label="copy-button">
              <mat-icon>content_copy</mat-icon>
            </button>
          </div>
          <mat-label class="mat-label-text" >Value</mat-label>
          <textarea class="idn-min-textarea-height" type="text" width="50" [value]="configValue" name="comment" matInput
            readonly></textarea>
        </mat-form-field>
      </form>
    </div>
    <div class="dialog-content" *ngIf="data.module == 'package-details'">
      <mat-tab-group mat-align-tabs="left" animationDuration="0ms">
        <mat-tab label="Extension Details" *ngIf="packageDetails?.parentSolutionPackage">
          <ng-template mat-tab-label>
            <mat-icon class="example-tab-icon">article</mat-icon>
            Parent Package
          </ng-template>
          <app-idn-table [data]="packageParentTable"></app-idn-table>
        </mat-tab>
        <mat-tab label="Extension Details" *ngIf="packageDetails?.childSolutionPackages?.length">
          <ng-template mat-tab-label>
            <mat-icon class="example-tab-icon">article</mat-icon>
            Child Package
          </ng-template>
          <app-idn-table [data]="packageChildTable"></app-idn-table>
        </mat-tab>
      </mat-tab-group>
    </div>
    <div class="dialog-content" *ngIf="data.module == 'partner-provisionedUser'">
      <div class="provision-container" *ngIf="partnerProvisionedUserData?.partners?.length">
        <h3>Partner User Allocation</h3>
        <div class="items" *ngFor="let item of partnerProvisionedUserData?.partners">
          <div class="partner-name">
            <span>{{item?.partnerName}}</span>
          </div>
          <div class="user-count">
            <span>{{item?.userProvisionedInInstance}} / {{item?.partnerUserQuota}} Users</span>
          </div>
        </div>
        
      </div>

      <div class="provision-container" *ngIf="partnerProvisionedUserData?.customer">
        <h3>Customer User Allocation</h3>
        <div class="items">
          <div class="partner-name">
            <span>{{partnerProvisionedUserData?.customer?.customerName}}</span>
          </div>
          <div class="user-count">
            <span>{{partnerProvisionedUserData?.customer?.userProvisionedInInstance}} / {{partnerProvisionedUserData?.customer?.customerUserQuota}} Users</span>
          </div>
        </div>
        
      </div>
    </div>
    <div class="dialog-content" *ngIf="data.module == 'error-details'">
      <div class="error-form">
        <span mat-dialog-title class="display-error" [innerHtml] ="configValue"></span>               
            <div class="copy-icon" *ngIf="isError">
              <button mat-button class="copy-button" [cdkCopyToClipboard]="configName" matTooltip="Copy Correlation ID" matTooltipPosition="above" aria-label="copy-button">
                <mat-icon>content_copy</mat-icon>
              </button>
            </div>               
      </div>
    </div>
    <div class="dialog-content" *ngIf="data.module == 'quick-actions'">
      <!-- <span>{{Select {{actionItem}}}}</span> -->
      <form class="action-items">
        <span *ngIf="isInstanceData && data.title == 'Instance Tools'">Select an instance to access instance tools.</span>
        <span *ngIf="isInstanceData && data.title == 'Deployment'">Select an instance to initiate deployment.</span>
        <span *ngIf="isInstanceData && data.title == 'Provision ICI Users'">Select an instance to provision ICI users.</span>
        <span *ngIf="!isInstanceData">Select a custom solution extension to navigate to it.</span>
        <mat-form-field class="pss-block-form">
          <mat-label>{{isInstanceData? "Instance Name" : "Extension Name"}}</mat-label>
          <mat-select disableOptionCentering (selectionChange)="selectedData($event)" #selectItem required >
            <mat-option>
              <ngx-mat-select-search placeholderLabel="{{isInstanceData? 'Search Instance' : 'Search Extension'}}"
                  noEntriesFoundLabel="No data found" [formControl]="columnFilterInstance">
              </ngx-mat-select-search>
            </mat-option>
            <mat-option *ngFor="let data of instanceData" [value]="isInstanceData? data.instanceRequestId : data.extensionId">
                  {{isInstanceData? data.instanceName : data.extensionName}}
              </mat-option>
          </mat-select>
          <!-- <mat-error *ngIf="frmCreateInstance.controls.customerId.invalid">{{StateEnum.INSTCname}}</mat-error> -->
      </mat-form-field>
      </form>
    </div>
  </div>
  <div mat-dialog-actions [align]="'center'">
    <button *ngIf="data?.confirmText" mat-button [mat-dialog-close]="data.module == 'quick-actions'? selectItem : true" class="pss-dialog-focused-button min-width-button" cdkFocusInitial>{{ data.confirmText }}</button>
    <button mat-stroked-button  class="mat-flat-button min-width-button mat-primary"  [cdkCopyToClipboard]="copyMessage" aria-label="Copy Button"  *ngIf="data.module == 'error-details'">Copy</button>
    <button mat-stroked-button [mat-dialog-close]="false" class="min-width-button idn-btn-cancel">{{ data.cancelText }}</button>
  </div>

</div>
